module.exports = __webpack_public_path__ + "img/ky.b7091600.svg";